import React, { useState, useEffect } from 'react';


const Header = ({ scrollToContact }) => {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className="relative bg-bgLight">
            <nav
                className={`fixed z-50 transition-all duration-500 flex items-center justify-between 
                    ${isScrolled
                        ? 'top-4 left-0 right-0 bg-white/95 backdrop-blur-md shadow-xl rounded-[24px] max-w-7xl mx-auto w-[calc(100%-2rem)] lg:w-[calc(100%-4rem)] px-4 sm:px-10 h-16'
                        : 'top-0 left-0 right-0 bg-white shadow-sm px-4 sm:px-12 h-20 sm:h-24 w-full'
                    }`}
            >
                {/* Left Side: Logo + Nav Links + Buttons */}
                <div className="flex items-center gap-4 sm:gap-8 w-full">
                    {/* Logo */}
                    <div className="flex items-center">
                        <img
                            src={process.env.PUBLIC_URL + "/videos/excalibur-logo.png"}
                            alt="Excalibur Projects Business Logo"
                            loading="eager"
                            className={`w-auto object-contain transition-all duration-500 ${isScrolled ? 'h-10 sm:h-12' : 'h-14 sm:h-18'}`}
                        />
                    </div>

                    {/* Spacer to push everything to the right */}
                    <div className="flex-grow"></div>

                    {/* Nav Links + Contact Button grouped on the right */}
                    <div className="flex items-center gap-2 sm:gap-8">
                        <div className={`hidden md:flex items-center gap-8 text-primary/80`}>
                            <a href="#services" className="hover:text-primary transition-colors font-bold">Services</a>
                            <a href="#about" className="hover:text-primary transition-colors font-bold">About Us</a>
                        </div>

                        {/* Contact Us - Rounded & Right Aligned */}
                        <button
                            onClick={scrollToContact}
                            className="inline-flex px-4 sm:px-8 h-10 sm:h-12 bg-logo-gradient hover-logo-gradient text-white rounded-[12px] font-bold transition-all shadow-lg items-center justify-center whitespace-nowrap text-xs sm:text-base"
                        >
                            Contact Us
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
